<template>
  <div>
    <h1 class="page-header">
      {{ $t('administration.employee.employeeCardActivator.cardActivator') }}
    </h1>
    <div class="row">
      <div class="col-lg-3 col-md-5 col-sm-12">
        <ts-card>
          <ts-card-wrapper>
            <form-create
              @success_create="fetchData"
              :edit="edit_data"
              :leave="route_leave"
              @success_update="edit_data = ''"
              @cancel="fetchData"
            ></form-create>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div class="col-lg-9 col-md-7 col-sm-12">
        <ts-card>
          <ts-card-wrapper>
            <div class="row">
              <div
                class="col-lg-9 com-md-9 col-sm-12 d-flex justify-content-start"
              ></div>
              <div
                class="col-lg-3 com-md-3 col-sm-12 d-flex justify-content-end ts-space-x-2"
              >
                <select
                  class="form-control"
                  v-model.number="status_id"
                  style="width: 120px"
                  @change="fetchData()"
                >
                  <option :value="1">Active</option>
                  <option :value="2">In Active</option>
                </select>
                <ts-input
                  v-model="search"
                  :placeholder="$t('search')"
                  style="width: 300px"
                />
              </div>
            </div>
          </ts-card-wrapper>
          <div class="overflow-auto">
            <ts-loading-banner>
              <Table
                :columns="columns"
                :data="resources"
                :loading="loading"
                max-height="700"
                stripe
                highlight-row
                size="small"
              >
                <template slot-scope="{ row }" slot="branch_name_en">
                  {{ row.branch ? row.branch.branch_name_en : '' }}
                </template>
                <template slot-scope="{ row }" slot="name_info">
                  {{
                    row.employee
                      ? row.employee.name_en + '|' + row.employee.name_kh
                      : ''
                  }}
                </template>
                <template slot-scope="{ row }" slot="status_id">
                  <span class="label label-success" v-if="row.status_id == 1"
                    >Active</span
                  >
                  <span class="label label-default" v-if="row.status_id == 2"
                    >Inactive</span
                  >
                </template>
                <template slot-scope="{ row }" slot="action">
                  <a
                    href="#"
                    v-tooltip="$t('studentCardActivator.changeStatus')"
                    class="text-primary"
                    @click.prevent="change(row)"
                  >
                    <i class="fas fa-random"></i>
                  </a>
                </template>
              </Table>
            </ts-loading-banner>
          </div>
          <div class="d-flex justify-content-between align-items-center p-15">
            <ts-total-list v-model="pagination" />
            <ts-pagination
              v-model="pagination"
              @navigate="fetchData"
            ></ts-pagination>
          </div>
        </ts-card>
      </div>
    </div>
  </div>
</template>
>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FormCreate from './form.vue'
import FormComponent from './confirm-deactivate-old-card.vue'
export default {
  components: {
    FormCreate,
    FormComponent
  },
  name: 'employee-card-activator',
  props: ['editData'],
  data () {
    return {
      edit_data: this.editData,
      loading: false,
      route_leave: false
    }
  },
  created () {
    this.fetchData()
  },
  computed: {
    ...mapState('employeeCardActivator', ['resources', 'pagination']),
    search: {
      get () {
        return this.$store.state.employeeCardActivator.search
      },
      set (newVal) {
        this.$store.commit('employeeCardActivator/SET_SEARCH', newVal)
        this.$store.commit('employeeCardActivator/RESET_CURRENT_PAGE')
      }
    },
    status_id: {
      get () {
        return this.$store.state.employeeCardActivator.status_id
      },
      set (newVal) {
        this.$store.commit('employeeCardActivator/SET_STATUS_ID', newVal)
      }
    },
    columns () {
      return [
        {
          title: this.$t(
            'administration.employee.employeeCardActivator.branch'
          ),
          slot: 'branch_name_en',
          minWidth: 80
        },
        {
          title: this.$t(
            'administration.employee.employeeCardActivator.employeeName'
          ),
          slot: 'name_info',
          minWidth: 120
        },
        {
          title: this.$t(
            'administration.employee.employeeCardActivator.serialCard'
          ),
          key: 'serial_card',
          minWidth: 100
        },
        {
          title: this.$t(
            'administration.employee.employeeCardActivator.registerDate'
          ),
          key: 'registered_date',
          minWidth: 100
        },
        {
          title: this.$t(
            'administration.employee.employeeCardActivator.status'
          ),
          slot: 'status_id',
          minWidth: 30,
          align: 'center'
        },
        {
          title: this.$t(
            'administration.employee.employeeCardActivator.reason'
          ),
          key: 'reason',
          minWidth: 100
        },
        {
          title: this.$t('actions'),
          key: 'action',
          slot: 'action',
          fixed: 'right',
          align: 'center',
          width: 100
        }
      ]
    }
  },
  methods: {
    fetchData (attributes) {
      this.loading = true

      this.$store
        .dispatch('employeeCardActivator/fetch', attributes)
        .then(() => (this.loading = false))
        .catch(error => {
          this.$toasted.error(error.message)
          this.loading = false
        })
    },
    change (record) {
      this.$modal.show(
        FormComponent,
        {
          data: {
            staff_id: parseInt(record.staff_id),
            serial_card: ''
          }
        },
        {
          height: 'auto',
          width: '330px',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        }
      )
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave (to, from, next) {
    if (_.isEmpty(to.params) && to.name != 'employee-card-activator-create') {
      this.$store.commit('employeeCardActivator/RESET_STATE')
      this.$store.commit('employeeCardActivator/SET_EMPLOYEES', [])
      this.fetchData()
      this.route_leave = true
    }
    next()
  }
}
</script>
